<template>
<div>
  <payroll-filter v-model="params" @search="searchPayroll"/>
  <pdf-reader />
  <vs-card>
    <div id="payroll-table-loading" class="vs-con-loading__container">
      <vs-row>
        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
          <payroll-table :filter="params" :data="payrollList" @loadMore="loadMore" @search="searchPayroll" @sort="sort" @showPdf="showPdf" />
        </vs-col>
      </vs-row>
    </div>
  </vs-card>
</div>
</template>

<script>
import modulePayroll from '@/store/payroll/modulePayroll.js'
import PayrollTable from './components/PayrollTable'
import PayrollFilter from './components/PayrollFilter'
import AddButton from '@/views/components/buttons/AddButton'
import loading from '@/mixins/Loading'
import PdfReader from '@/components/pdf/PdfReader.vue'
import payroll from '@/http/requests/payroll'
import { BASE_URL } from '@/urls.js'
export default {
  components: {
    PayrollTable,
    PayrollFilter,
    AddButton,
    PdfReader
  },
  computed: {
    payrollList() {
      return this.$store.state.payroll.payrollList
    },
    isLoading(){
      return this.loading.filter || this.loading.pdf
    }
  },
  created() {
    if (!modulePayroll.isRegistered) {
      this.$store.registerModule('payroll', modulePayroll)
      modulePayroll.isRegistered = true
    }
  },
  data: () => ({
    lastPage: '',
    params: {
      client_id: [],
      status_id: [],
      start_week: '',
      end_week: '',
      sortBy: ['p.PeriodId', 'payrolls.InvoiceId', 'payroll_no'],
      sort: ['DESC', 'ASC', 'ASC'],
      new_registers: true
    },
    search: '',
    payrolls: [],
    page: 1,
    loading:{
      filter:false,
      pdf:false
    }
  }),
  methods: {
    getPayrolls() {
      this.loading.filter = true
      let data = Object.assign({}, this.params);
      data.page = this.page
      data.search = this.search
      this.$store
        .dispatch('payroll/fetchPayrollList', data)
        .then((res) => {
          this.lastPage = res.data.last_page
          this.loading.filter = false
        })
        .catch((err) => {
          this.loading.filter = false
        })
    },

    init() {
      this.getPayrolls()
    },

    loadMore() {
      if (this.page >= this.lastPage) {
        return
      }
      this.page++
      this.getPayrolls()
    },

    searchPayroll(text) {
      this.search = text
      this.page = 1
      this.getPayrolls()
    },

    sort(e) {
      this.params.sortBy = e.sortBy
      this.params.sort = e.sort
      this.getPayrolls()
    },

    showPdf(data) {
      let title = `Payroll`;
      let files = [];

      if(data.file === 'auto_generate'){
        this.loading.pdf = true
        payroll.getFile(data.id)
          .then((res) => {
            files.push({
              name: 'Payroll',
              source: BASE_URL + 'storage/' + res.data.file,
            })
            this.loading.pdf = false
            this.$store.dispatch('togglePdfReader', {
              active: true,
              files: files,
              title: title,
            })

          })
          .catch((res) => {
              this.loading.pdf = false
          });
      }else{
        files.push({
          name: 'Payroll',
          source: BASE_URL + 'storage/' + data.file,
        })
        this.$store.dispatch('togglePdfReader', {
          active: true,
          files: files,
          title: title,
        })
      }
    },

  },
  mixins: [loading],
  mounted() {
    this.init()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`payroll-table-loading`)
      } else {
        this.closeLoading(`payroll-table-loading`)
      }
    },
  }
}
</script>

<style>
</style>
